<!--
 * @Description: GPS设备
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-12-29 14:53:39
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header v-if="!isOpenNew">
        <breaDcrumb />
      </el-header>
      <el-main>
        <div v-if="!isOpenNew">
          <div v-show="showCardNav">
            <div class="search" style="padding-bottom: 0">
              <span style="display: inline-block; margin-bottom: 10px">
                <span style="margin-right: 12px">车牌号</span>
                <el-select v-model="tableParam.carNos" style="width: 220px" multiple clearable filterable placeholder="请选择">
                  <el-option v-for="item in carNoList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">车队名称:</span>
                <el-input v-model="tableParam.carTeamName" style="width: 220px" clearable placeholder="请输入" @keyup.enter.native="gettableData()" />
              </span>
              <span style="margin-left: 24px">
                <span style="margin-right: 12px">站点名称</span>
                <el-select v-model="tableParam.stationNameList" style="width: 220px" multiple clearable filterable placeholder="请选择">
                  <el-option v-for="item in stationList" :key="item" :label="item" :value="item"></el-option>
                </el-select>
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="gettableDataMap(), resetTimer()">查 询</el-button>
              <el-button size="medium" class="bottom_all" style="margin-left: 12px" @click="(carManagerDig = true), getCarManager()">车辆维护</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 12px" @click="(refreshDig = true), (newRefreshTime = refreshTime)">自动刷新设置</el-button>
            </div>
          </div>
        </div>
        <div v-loading="mapLoading" :style="{height: isOpenNew ? 'calc(100vh)':'calc(100vh - 275px)'}">
          <el-amap ref="amapManager" vid="amapDemo" :center="mapCenter" :zoom="zoom" class="amap-demo" :events="events" :zooms="[3, 18]" @zoomchange="handleZoomChange">
            <el-amap-marker
              v-for="(item, index) in markers"
              :key="index + 100"
              :position="item.position"
              :vid="item.vid"
              :content="setMarkerContent(item)"
              :offset="item.offset"
              :label="item.label"
            ></el-amap-marker>
            <el-amap-circle v-for="(item, index) in circles" :key="index + 'circles'" :center="item.center" :radius="item.radius" :fill-opacity="item.fillOpacity" :bubble="true" :events="item.events"></el-amap-circle>
            <el-amap-circle
              v-for="(item, index) in circles2"
              :key="index + 'circles2'"
              :center="item.center"
              :radius="item.radius"
              strokeColor="#FF0000"
              fillColor="#FF0033"
              :fill-opacity="item.fillOpacity"
              :bubble="true"
              :events="item.events"
            >
            </el-amap-circle>
            <el-amap-info-window :visible="infoVisible" :position="infoCenter">
              <div>{{ infoText }}</div>
            </el-amap-info-window>
          </el-amap>
        </div>
      </el-main>
      <el-dialog title="自动刷新设置" :visible.sync="refreshDig" width="300px">
        <span style="display: inline-block; margin-bottom: 10px">
          <span style="margin-right: 12px">自动刷新时间:</span>
          <el-input-number v-model="newRefreshTime" :min="1" style="width: 80px" :controls="false" placeholder="请输入"> </el-input-number>
          <span style="margin-left: 10px">min</span>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="refreshDig = false">取 消</el-button>
          <el-button type="primary" @click="setRefreshTime">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 车辆维护 -->
      <el-dialog v-dialogDrag :visible.sync="carManagerDig" width="1280px" :close-on-click-modal="false">
        <span slot="title" class="dialog-title">车辆维护</span>
        <div class="search">
          <span style="display: inline-block; margin-bottom: 10px">
            <span style="margin-right: 12px">车牌号</span>
            <el-input v-model="carManagerParams.carNo" style="width: 150px" placeholder="请输入" clearable @keyup.enter.native="getCarManager()" />
          </span>
          <span style="margin-left: 24px">
            <span style="margin-right: 12px">车队名称:</span>
            <el-input v-model="carManagerParams.carTeamName" style="width: 150px" placeholder="请输入" clearable @keyup.enter.native="getCarManager()" />
          </span>
          <span style="margin-left: 24px">
            <span style="margin-right: 12px">站点名称</span>
            <el-input v-model="carManagerParams.stationName" style="width: 150px" placeholder="请输入" clearable @keyup.enter.native="getCarManager()" />
          </span>
          <span style="margin-left: 24px">
            <span style="margin-right: 12px">类型</span>
            <el-select v-model="carManagerParams.type" style="width: 120px" placeholder="请选择">
              <el-option :key="1" label="全部" value=""> </el-option>
              <el-option :key="2" label="已传输" :value="2"> </el-option>
              <el-option :key="3" label="未传输" :value="1"> </el-option>
            </el-select>
          </span>
          <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="getCarManager()">查 询</el-button>
        </div>
        <div style="margin-left: 24px">
          <el-button size="small" class="bottom_all" @click="addCarManger('添加')">添 加</el-button>
        </div>
        <div class="dialoginfo">
          <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="carManagerData" tooltip-effect="dark">
            <el-table-column align="center" label="车牌号" prop="carNo"></el-table-column>
            <el-table-column align="center" label="设备ID" prop="terminalPhone"></el-table-column>
            <el-table-column align="center" label="GPS厂家名称" prop="companyName"></el-table-column>
            <el-table-column align="center" label="车队名称" prop="carTeamName"></el-table-column>
            <el-table-column align="center" label="站点名称" prop="stationName"></el-table-column>
            <el-table-column align="center" label="更新时间" prop="time"></el-table-column>
            <el-table-column align="center" label="类型" prop="sureTransfer">
              <template slot-scope="scope">
                <span v-if="scope.row.sureTransfer == 1">未传输</span>
                <span v-else-if="scope.row.sureTransfer == 2">已传输</span>
              </template>
            </el-table-column>
            <el-table-column align="center" label="操作">
              <template slot-scope="scope">
                <el-link class="table_link" :underline="false" @click="addCarManger('修改', scope.row)">修改</el-link>
                <el-link style="margin-left: 10px" type="danger" :underline="false" @click="deleteCarManager(scope.row)">删除</el-link>
              </template>
            </el-table-column>
          </el-table>
          <div class="card_bottom">
            <div class="card_bottom_left">
              <div class="top_page_totle">总共{{ carManagerParams.total }}条</div>
              <el-pagination
                :current-page.sync="carManagerParams.page"
                :page-size="carManagerParams.pageSize"
                :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
                layout="prev,pager,sizes,next,jumper"
                :total="carManagerParams.total"
                @size-change="sizeChange"
                @current-change="getCarManager()"
              ></el-pagination>
            </div>
            <div>
              <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="pagesgettableData()">刷新</el-button>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="carManagerDig = false">关 闭</el-button>
        </span>
      </el-dialog>
      <!-- 添加车辆维护信息 -->
      <el-dialog v-dialogDrag :title="addCarManagerText" :visible.sync="addCarManagerDig" width="500px" :close-on-click-modal="false" @close="colseAddCarManager">
        <el-form ref="carManagerForm" :model="carManagerForm" :rules="rules" class="demo-form" label-width="auto" label-position="right">
          <el-form-item label="车牌号 ：" prop="carNo">
            <el-input v-model="carManagerForm.carNo" style="width: 220px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="设备ID：" prop="terminalPhone">
            <el-input v-model="carManagerForm.terminalPhone" style="width: 220px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="GPS厂家名称：" prop="companyName">
            <el-input v-model="carManagerForm.companyName" style="width: 220px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="车队名称：" prop="carTeamName">
            <el-input v-model="carManagerForm.carTeamName" style="width: 220px" placeholder="请输入" />
          </el-form-item>
          <el-form-item label="站点名称：" prop="stationName">
            <el-select v-model="carManagerForm.stationName" style="width: 220px" placeholder="请选择">
              <el-option v-for="item in stationList" :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button class="bottom_all_two" @click="colseAddCarManager">取 消</el-button>
          <el-button class="bottom_all" type="primary" @click="saveCarManager">确 定</el-button>
        </span>
      </el-dialog>
    </el-container>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryCarNoList, queryStationList, queryCarPositionList, queryCarPositionPage, deleteCars, saveOrUpdateCars, stationQueryPage } from "@/api/smart/schedul/gpsDevice.js";
import { QueryPageElectronicFence } from "@/api/smart/schedul/j.js";
import { getUserInfo } from "@/utils/auth.js";
export default {
  mixins: [mixin],
  data() {
    return {
      UserInfo: "",
      principalName: "",
      currentWindow: {
        position: [104.045543, 30.53947],
        content: "",
        offset: [0, -20],
        visible: false,
        events: {},
      },
      searchOption: {
        city: "全国",
        citylimit: true,
      },
      markers: [],
      plugin: [],
      zoom: 14,
      events: {
        complete: () => {
          let overlaysList = this.$refs.amapManager.$$getInstance().getAllOverlays("marker");
          this.$refs.amapManager.$$getInstance().setFitView(overlaysList);
        },
      },
      mapCenter: [104.045543, 30.53947],
      /*表格数据*/
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      circles: [], //电子围栏
      circles2: [],
      mapLoading: false,
      stationList: [],
      carNoList: [],
      refreshDig: false,
      refreshTime: 10,
      newRefreshTime: 10,
      timer: "",
      //车辆维护-开始
      carManagerDig: false,
      carManagerData: [],
      addCarManagerDig: false,
      addCarManagerText: "添加",
      carManagerForm: {
        id: "",
        companyName: "",
        terminalPhone: "",
        carTeamName: "",
        stationName: "",
        carNo: "",
      },
      carManagerParams: {
        page: 1,
        pageSize: 10,
        total: 0,
        type: "",
        carTeamName: "",
        stationName: "",
        carNo: "",
      },
      rules: {
        carNo: [{ required: true, message: "请选择车牌号", trigger: "change" }],
        terminalPhone: [{ required: true, message: "请选择设备ID", trigger: "change" }],
        companyName: [{ required: true, message: "请选择GPS厂家名称", trigger: "change" }],
        carTeamName: [{ required: true, message: "请选择车队名称", trigger: "change" }],
        stationName: [{ required: true, message: "请选择站点名称", trigger: "change" }],
      },
      //车辆维护-结束
      infoVisible: true,
      infoCenter: [104.045543, 30.53947],
      infoText: "",
      zoomLevel: 14,
      isOpenNew:false,//判断是否新页面打开
    };
  },
  async created() {
    const query = this.$route.query;
    if(query.carNo){
      this.tableParam.carNos = [query.carNo]
      this.isOpenNew = true
    } else {
      this.isOpenNew = false
    }
    this.UserInfo = await getUserInfo();
    this.gettableDataMap();
    this.resetTimer();
    queryStationList({}).then(res => {
      if (res.code == 1001) {
        this.stationList = res.body;
      }
    });
    queryCarNoList({}).then(res => {
      if (res.code == 1001) {
        this.carNoList = res.body;
      }
    });
    
  },
  methods: {
    handleZoomChange() {
      this.zoomLevel = this.$refs.amapManager.$amap.getZoom();
      this.markers.forEach(marker => {
        // 根据缩放层级更新点的内容
        marker.content = this.setMarkerContent(marker);
      });
    },
    mouseOver(center, text) {
      console.log(center);
      this.infoVisible = true;
      this.infoCenter = center;
      this.infoText = text;
    },
    mouseOut() {
      this.infoVisible = false;
      this.infoCenter = this.$refs.amapManager.$amap.getCenter();
      this.infoText = "";
    },
    getEngineeringRange() {
      let json1 = {
        isAssess: "5",
        page: 1,
        pageSize: 999,
      };
      this.mapLoading = true;
      QueryPageElectronicFence(json1).then(res => {
        if (res.code == 1001) {
          this.circles = [];
          res.data.data.forEach(e => {
            if (e.longitude) {
              this.circles.push({
                center: [e.longitude, e.latitude],
                radius: e.distance,
                fillOpacity: 0.2,
                events: {
                  click: () => {},
                  mousemove: () => {
                    this.mouseOver([e.longitude, e.latitude], e.name);
                  },
                  mouseout: () => {
                    this.mouseOut();
                  },
                },
              });
            }
          });

          console.log(this.circles);
          stationQueryPage({ page: 1, pageSize: 99999 }).then(res => {
            if (res.code == 1001) {
              this.circles2 = [];
              res.data.data.forEach(e => {
                if (e.longitude) {
                  this.circles2.push({
                    center: [Number(e.longitude), Number(e.dimensionality)],
                    radius: Number(e.electronicFence) * 1000,
                    fillOpacity: 0.2,
                    events: {
                      click: () => {},
                      mousemove: () => {
                        this.mouseOver([Number(e.longitude), Number(e.dimensionality)], e.stationName);
                      },
                      mouseout: () => {
                        this.mouseOut();
                      },
                    },
                  });
                }
              });
              console.log(this.circles2);
            }
          });
          this.mapLoading = false;
          // this.$refs.amapManager.$amap.on("zoomchange", () => {
          //   this.handleZoomChange();
          // });
        }
      });
    },
    saveCarManager() {
      this.$refs["carManagerForm"].validate(valid => {
        if (valid) {
          saveOrUpdateCars(this.carManagerForm).then(res => {
            if (res.code == 1001) {
              this.$message.success("保存成功!");
              this.getCarManager();
              this.colseAddCarManager();
            }
          });
        } else {
          return false;
        }
      });
    },
    colseAddCarManager() {
      this.addCarManagerDig = false;
      this.carManagerForm = this.$options.data().carManagerForm;
    },
    addCarManger(text, row) {
      if (text == "添加") {
        this.addCarManagerText = text;
        this.addCarManagerDig = true;
      } else if (text == "修改") {
        this.addCarManagerText = text;
        this.carManagerForm = row;
        this.addCarManagerDig = true;
      }
    },
    deleteCarManager(row) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          deleteCars({ id: row.id }).then(res => {
            if (res.code == 1001) {
              this.getCarManager();
              this.$message({
                message: "删除成功",
                type: "success",
              });
            }
          });
        })
        .catch(() => {});
    },
    sizeChange(value) {
      this.carManagerParams.pageSize = value;
      this.getCarManager();
    },
    getCarManager() {
      queryCarPositionPage(this.carManagerParams).then(res => {
        if (res.code == 1001) {
          this.carManagerData = res.body.data;
          this.carManagerParams.total = res.body.totalRows;
        }
      });
    },
    resetTimer() {
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.gettableDataMap();
      }, 600000);
    },
    setRefreshTime() {
      this.refreshTime = this.newRefreshTime;
      let time = Number(this.refreshTime) * 60000;
      console.log(time);
      this.gettableDataMap();
      this.refreshDig = false;
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.gettableDataMap();
      }, time);
    },
    gettableDataMap() {
      // let _this = this;
      if(!this.isOpenNew){
        this.getEngineeringRange();
      }
      
      this.markers = [];
      queryCarPositionList(this.tableParam).then(res => {
        if (res.code == 1001) {
          if (res.body) {
            this.markers = [];
            const newArry = [];
            res.body.forEach(item => {
              const index = newArry.findIndex(items => items.carNo === item.carNo);
              if (index !== -1) {
                const oldTime = new Date(newArry[index].create_time).getTime();
                const newTime = new Date(item.create_time).getTime();
                if (newTime > oldTime) {
                  newArry.splice(index, 1, item);
                }
              } else {
                newArry.push(item);
              }
            });
            newArry.forEach((item, index) => {
              // let longitudeArr = String(item.longitude).split(".");
              // let latitudeArr = String(item.latitude).split(".");
              // let longitude = 0;
              // let latitude = 0;
              // if (longitudeArr[1].length == "3") {
              //   longitude = Number(item.longitude + "001");
              // }
              // if (longitudeArr[1].length == "4") {
              //   longitude = Number(item.longitude + "01");
              // }
              // if (latitudeArr[1].length == "3") {
              //   latitude = Number(item.latitude + "001");
              // }
              // if (latitudeArr[1].length == "4") {
              //   latitude = Number(item.latitude + "01");
              // }
              if (item.longitude && item.latitude) {
                let txt = item.carStatus == 0 ? item.carNo + "（离线" + item.offlineHours + "小时）" : item.carNo;
                const data = {
                  vid: index,
                  position: [item.longitude, item.latitude],
                  data: item,
                  offset: [-25, -22.5],
                  label: {
                    content: txt,
                    offset: [0, -20],
                  },
                  // events: {
                  //   click: () => {
                  //     console.log(112233);
                  //   },
                  //   mousemove: () => {
                  //     this.mouseOver([Number(item.longitude), Number(item.latitude)], txt);
                  //   },
                  //   mouseout: () => {
                  //     this.mouseOut();
                  //   },
                  // },
                  // content: this.setMarkerContent({ data: item }),
                };

                this.markers.push(data);
              }
            });
            console.log(this.markers);
            /**
             * @Description: 设置mapCenter
             * @param {*}
             * @Author: wangwangwang
             */
            // if (this.searchParams.carNo) {
            //   this.mapCenter = [newArry[0].longitude, newArry[0].latitude];
            // } else {
            //   const station = this.stationList.find(item => item.id === this.searchParams.stationId);
            //   this.mapCenter = [station.longitude, station.dimensionality];
            // }
          }
        }
      });
    },
    setMarkerContent(data) {
      const imgUri = require("@/assets/guanCheNew.png");
      const outimgUri = require("@/assets/guanCheOutNew.png");
      const content = `<img src=${data.data.carStatus == 0 ? outimgUri : imgUri} style="width:50px;"/>`;
      // const content = `<div style="text-align:center;min-width:100px;font-size:13px;">
      //                   <div style="padding:0 14px; border:1px solid #000; border-radius: 5px;background:#fff;min-width:100px;${data.data.carStatus == 0 ? "color:red" : ""}">${data.data.carNo || ""}${
      //   data.data.carStatus == 0 ? "（离线" + data.data.offlineHours + "小时）" : ""
      // } </div>
      //                   <img src=${data.data.carStatus == 0 ? outimgUri : imgUri} style="width:80px;"/>
      //                  </div>`;
      return content;
    },
  },
};
</script>
<style lang="scss" scoped>
.table_link {
  margin: 0 10px;
  color: $bg_color;
  cursor: pointer;
}

.table_link:hover {
  opacity: 0.8;
}
</style>